export class LogInRequest {
    constructor(
        public userName: string,
        public encryptedPassword: string,
        public rememberMe: boolean) {
    }
}

export class LogInResponse {
    constructor(
        public isSuccess: boolean,
        public message: string
    ) { }
}